<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FaI1U7/images/9780819572363.jpg?1689948028931" alt="This image is the cover for the book Eleven More American Women Poets in the 21st Century"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Eleven More American Women Poets in the 21st Century
      </h1>
      <p class="bookDescription body article font2">
        <b>“A fine and selective anthology that’s also a critical introduction to some of the most provocative, and some of the most original, poetry out there.” —Stephanie Burt, author of <i>Don’t Read Poetry: A Book About How to Read Poems</i></b><br/><br/> The American Poets in the 21st Century series continues with another anthology focused on female poets. Like the earlier books, this volume includes generous selections of poetry by some of the best poets of our time as well as illuminating poetics statements and incisive essays on their work. This unique organization makes these books invaluable teaching tools.<br/><br/> Broadening the lens through which we look at contemporary poetry, this new volume extends its geographical net by including Caribbean and Canadian poets. Representing three generations of women writers, among the insightful pieces included in this volume are essays by Karla Kelsey on Mary Jo Bang’s modes of artifice, Christine Hume on Carla Harryman’s kinds of listening, Dawn Lundy Martin on M. NourbeSe Phillip (for whom “english / is a foreign anguish”), and Sina Queyras on Lisa Robertson’s confoundingly beautiful surfaces. In addition, a companion website presents audio of each poet’s work.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Claudia Rankine, Lisa Sewell
      </h2>
      
      <p class="authorDescription body article">CLAUDIA RANKINE is the Henry G. Lee Professor of English at Pomona College and author of Don't Let Me Be Lonely. LISA SEWELL is a professor of English at Villanova University and the author of Name Withheld.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wesleyan University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?02202042